/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type HumanityDeployContractInfo = {
    ADDR: string;
    CNM: string;
    CMP: string;
    CMPVER: string;
    BL: string;
    TRXCNT: string;
    OPT: HumanityDeployContractInfo.OPT;
    DPLUT: number;
};

export namespace HumanityDeployContractInfo {

    export enum OPT {
        Y = 'Y',
        N = 'N',
    }


}

